const areMandatoryOptionsSelected = (selectedOptions, addOns) => {
    const selectedOptionIds = selectedOptions.map(opt => opt.id);
    
    const mandatoryOptionIds = addOns
    .flatMap(addon => addon.options || [])
    .filter(option => option.isMandatory)
    .map(option => option.optionId);
    
    return mandatoryOptionIds.every(id => selectedOptionIds.includes(id));
}

export default areMandatoryOptionsSelected;